<template>
  <card class="card" title="Cadastro de Lead">
    <div class="row">
      <div class="col-md-3">
        <div>
          <input
            type="checkbox"
            id="fidelidade"
            name="fidelidade"
            v-model="isBusiness"
          />
          <label for="jurídica">
            <span class="p_jurídica">Pessoa Jurídica ?</span>
          </label>
        </div>
      </div>
    </div>
    <div>
      <form @submit.prevent="createLead">
        <div class="row">
          <div class="col-md-2">
            <fg-input
              type="text"
              label="CPF/CNPJ"
              v-mask="'##############'"
              v-model="lead.taxId"
              required
            ></fg-input>
          </div>
          <div class="col-md-4">
            <fg-input
              type="text"
              label="Nome"
              @keyup.native="toUpperName"
              v-model="lead.name"
              required
            ></fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              type="date"
              label="Data de Nasc."
              v-model="lead.birthDate"
              :required="!isBusiness"
              v-show="!isBusiness"
            ></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input
              type="text"
              label="Nome da Mãe"
              @keyup.native="toUpperMotherName"
              v-model="lead.motherName"
              v-show="!isBusiness"
            ></fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              type="text"
              label="E-mail Financeiro"
              @keyup.native="toUpperEmail"
              v-model="lead.email"
              v-show="!isBusiness"
            ></fg-input>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="exampleFormControlTextarea1" v-show="!isBusiness">Gênero</label>
              <select class="form-control input i-width" v-model="lead.gender" v-show="!isBusiness">
                <option :value="null" selected disabled>Selecione...</option>
                <option value="1">Masculino</option>
                <option value="2">Feminino</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <fg-input
              type="text"
              label="R.G /I.E"
              @keyup.native="toUpperRG"
              :required="!isBusiness"
              v-show="!isBusiness"
              v-model="lead.rg"
            ></fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              type="text"
              label="Orgão Exp. RG"
              :required="!isBusiness"
              v-show="!isBusiness"
              v-model="lead.orgaoRG"
              @keyup.native="toExpSliced"
            ></fg-input>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="exampleFormControlTextarea1" v-show="!isBusiness">Tipo de Assinante</label>
              <select class="form-control input i-width" v-model="lead.subscriberType" v-show="!isBusiness">
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.subscriberTypes" :key="f.id" :value="f.id">{{ f.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <fg-input
              type="text"
              label="Celular"
              v-mask="'(##) #####-####'"
              v-model="lead.phone"
              v-show="!isBusiness"
            ></fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              type="text"
              label="Telefone Residencial"
              v-mask="'(##)#########'"
              v-model="lead.residentialPhone"
              v-show="!isBusiness"
            ></fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              type="text"
              label="Telefone Comercial"
              v-mask="'(##)#########'"
              v-model="lead.commercialPhone"
              v-show="!isBusiness"
            ></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Origem</label>
              <select class="form-control input i-width" v-model="lead.origin" required>
                <option :value="null" selected disabled>Selecione...</option>
                <option value="dashboard">Plataforma (Interno)</option>
                <option value="seller">Plataforma (Externo)</option>
              </select>
            </div>
          </div>
        </div>

        <hr>
        <br />
        <span>Endereço do assinante</span>
        <div class="row">
          <div class="col-md-3">
            <fg-input
              type=""
              label="CEP"
              v-mask="'########'"
              v-model="lead.zipCode"
              v-show="!isBusiness"
              @blur="fetchCEP"
            ></fg-input>
          </div>

          <div class="col-md-6">
            <fg-input
              type="text"
              label="Endereço"
              @keyup.native="toUpperAddress"
              v-model="lead.address"
              v-show="!isBusiness"
            ></fg-input>
          </div>
          <div class="col-md-2">
            <fg-input
              type="number"
              label="Número"
              v-model="lead.addressNumber"
              v-show="!isBusiness"
            ></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input
              type="text"
              label="Estado(UF)"
              placeholder="Ex: SP"
              @keyup.native="toUpperState"
              v-model="lead.state"
              v-show="!isBusiness"
            >
            </fg-input>
          </div>

          <div class="col-md-4">
            <fg-input
              type="text"
              label="Cidade"
              @keyup.native="toUpperCity"
              v-model="lead.city"
              v-show="!isBusiness"
            ></fg-input>
          </div>
          <div class="col-md-4">
            <fg-input
              type="text"
              label="Bairro"
              @keyup.native="toUpperDistrict"
              v-model="lead.district"
              v-show="!isBusiness"
            ></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <fg-input
              type="text"
              label="Complemento"
              @keyup.native="toUpperAddressExtra"
              v-model="lead.addressExtra"
              v-show="!isBusiness"
            ></fg-input>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="exampleFormControlTextarea1" v-show="!isBusiness">Área</label>
              <select class="form-control input i-width" v-model="lead.area" v-show="!isBusiness">
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.subscriberAreas" :key="f.id" :value="f.id">{{ f.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <hr>
        <br />
        <span>Plano e data do pedido</span>
        <br>
        <span style="font-size: 14px"
        >Altere entre as opções abaixo para mudar o
          <strong>tipo de plano de mensalidade</strong></span
        >
        <div class="row col-md-6">
          <input
            type="radio"
            id="planos"
            name="fav_language"
            value="plan"
            v-model="lead.planType"
            checked
          />
          <label class="text-span" for="planos"
          ><span class="mg-left">Plano</span></label
          ><br />
          <input
            class="gap-left"
            type="radio"
            id="combos"
            name="fav_language"
            value="combo"
            v-model="lead.planType"
          />
          <label class="text-span" for="combos"
          ><span class="mg-left">Combo</span></label
          ><br />
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group" v-if="lead.planType === 'plan'">
              <label for="exampleFormControlTextarea1">Selecione o plano</label>
              <select
                v-model="lead.planId"
                class="form-control input i-width"
                required
              >
                <option :value="null" selected disabled>Selecione...</option>
                <option
                  v-for="plan in plans"
                  :key="plan.planId"
                  :value="plan.planId"
                >
                  {{ plan.name }}
                </option>
              </select>
            </div>
            <div class="form-group" v-if="lead.planType === 'combo'">
              <label for="exampleFormControlTextarea1">Selecione o combo</label>
              <select
                v-model="lead.planId"
                class="form-control input i-width"
                required
              >
                <option :value="null" selected disabled>Selecione...</option>
                <option
                  v-for="plan in combos"
                  :key="plan.id"
                  :value="plan.internetPlan.id"
                >
                  {{ plan.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <fg-input
              type="date"
              label="Data"
              v-model="lead.createdAt"
              v-show="!isBusiness"
            ></fg-input>
          </div>
        </div>

        <hr>
        <br />
        <span>Outras informações</span>
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label for="exampleFormControlTextarea1" v-show="!isBusiness">Tipo de Contrato</label>
              <select class="form-control input i-width" v-model="lead.contractType" v-show="!isBusiness">
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.contractTypes" :key="f.id" :value="f.id">{{ f.name }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-5">
            <div class="form-group">
              <label for="exampleFormControlTextarea1" v-show="!isBusiness"
                >Carteira de Cobrança</label
              >
              <select class="form-control input i-width" v-model="lead.cartCob" v-show="!isBusiness">
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.cobCarts" :key="f.id" :value="f.id">{{ f.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label for="exampleFormControlTextarea1" v-show="!isBusiness">Vendedor</label>
              <select class="form-control input i-width" v-model="lead.seller" :required="!isBusiness"
              v-show="!isBusiness">
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.sellers" :key="f.id" :value="f.id">{{ f.name }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="exampleFormControlTextarea1" v-show="!isBusiness">Dia de Vencimento</label>
              <select class="form-control input i-width" v-model="lead.expirationDay" v-show="!isBusiness">
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.expirationDates" :key="f.id" :value="f.id">{{ f.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label v-show="!isBusiness">Mensagem</label>
              <textarea
                rows="5"
                class="form-control border-input"
                v-model="lead.message"
                v-show="!isBusiness"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>

        <div class="container_buttons">
          <button class="btn-custom btn-salvar">Criar Lead</button>
        </div>
      </form>
    </div>
  </card>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "CreateLead",
  computed: {
    plans() {
      return this.$store.getters.plans;
    },
    combos() {
      return this.$store.getters.combos;
    },
    field() {
      return this.$store.getters.leadFields;
    },
  },
  data() {
    return {
      lead: {
        name: "",
        taxId: "",
        email: "",
        phone: "",
        city: "",
        address: "",
        addressNumber: "",
        zipCode: "",
        state: "",
        district: "",
        addressExtra: "",
        area: null,
        planId: null,
        planType: 'plan',
        createdAt: "",
        subject: "",
        message: "",
        birthDate: "",
        motherName: "",
        gender: null,
        origin: null,
        rg: "",
        orgaoRG: "",
        subscriberType: null,
        residentialPhone: "",
        commercialPhone: "",
        contractType: null,
        cartCob: null,
        seller: null,
        expirationDay: null,
      },
      isBusiness: false,
    };
  },
  methods: {
    ...mapActions(["addLead", "fetchPlans", "fetchLeadFields", "fetchCombos"]),
    toUpperName(e) {
      this.lead.name = e.target.value.toUpperCase();
    },
    toUpperMotherName(e) {
      this.lead.motherName = e.target.value.toUpperCase();
    },
    toUpperRG(e) {
      this.lead.rg = e.target.value.toUpperCase();
    },
    toUpperAddress(e) {
      this.lead.address = e.target.value.toUpperCase();
    },
    toUpperEmail(e) {
      this.lead.email = e.target.value.toUpperCase();
    },
    toUpperCity(e) {
      this.lead.city = e.target.value.toUpperCase();
    },
    toUpperAddressExtra(e) {
      this.lead.addressExtra = e.target.value.toUpperCase();
    },
    toUpperAddress(e) {
      this.lead.address = e.target.value.toUpperCase();
    },
    toUpperState(e) {
      this.lead.state = e.target.value.toUpperCase().slice(0, 2);
    },
    toExpSliced(e) {
      this.lead.orgaoRG = e.target.value.toUpperCase().slice(0, 6);
    },
    toUpperDistrict(e) {
      this.lead.district = e.target.value.toUpperCase();
    },
    toUpperSubject(e) {
      this.lead.subject = e.target.value.toUpperCase();
    },
    async createLead() {
      if (this.lead.taxId.length !== 11 && this.lead.taxId.length !== 14) {
        Swal.fire("Ops!", "CPF/CNPJ inválido", "error");
        return;
      }
      try {
        await this.addLead({
          lead: {
            ...this.lead,
          },
        });
        Swal.fire("Sucesso!", "Lead criado com sucesso", "success");
        this.$router.push("/leads");
      } catch (err) {
        Swal.fire("Ops!", "Não foi possível criar o lead", "error");
      }
    },
    async fetchCEP(e) {
      const cep = e.target.value;
      try {
        const {data} = await axios.get(`https://brasilapi.com.br/api/cep/v2/${cep}`);
        this.lead.city = data.city;
        this.lead.address = data.street;
        this.lead.state = data.state;
        this.lead.district = data.neighborhood;
      } catch(err) {
        console.error("Could not get CEP", err);
      }
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchPlans(),
        this.fetchCombos(),
        this.fetchLeadFields(),
      ]);
    } catch (err) {
      Swal.fire({
        title: "Ops!",
        text: "Não foi possível carregar os planos",
        icon: "error",
      });
    }
  },
};
</script>


<style lang="scss" scoped>
input[type="radio"] {
  width: 18px;
}
.text-span {
  font-weight: bold;
  color: #000;
  font-size: 16px;
}
.gap-left {
  margin-left: 10px;
}
.mg-left {
  margin-left: 3px;
}
.p_jurídica {
  font-size: 18px;
  margin-left: 5px;
}
span {
  font-size: 22px;
  font-weight: bold;
}
.container_buttons {
  display: flex;
  justify-content: center;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-salvar {
    background: #9dcf6b;
    padding: 13px 25px;
    &:hover {
      background: #82ac58;
    }
  }

  &.btn-analise {
    margin-left: 10px;
    background: orange;
    &:hover {
      background: #c07e03;
    }
  }

  &.btn-interesse {
    margin-left: 10px;
    background: #b80a0a;
    &:hover {
      background: #700202;
    }
  }
}
</style>
